(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
                  class StickyHeader extends HTMLElement {
                  constructor() {
                  super();
                  }

                  connectedCallback() {
                  this.header = document.getElementById('shopify-section-header');
                  this.headerBounds = {};
                  this.currentScrollTop = 0;
                  this.preventReveal = false;
                  this.predictiveSearch = this.querySelector('predictive-search');

                  this.onScrollHandler = this.onScroll.bind(this);
                  this.hideHeaderOnScrollUp = () => this.preventReveal = true;

                  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
                  window.addEventListener('scroll', this.onScrollHandler, false);

                  this.createObserver();
                  }

                  disconnectedCallback() {
                  this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
                  window.removeEventListener('scroll', this.onScrollHandler);
                  }

                  createObserver() {
                  let observer = new IntersectionObserver((entries, observer) => {
                  this.headerBounds = entries[0].intersectionRect;
                  observer.disconnect();
                  });

                  observer.observe(this.header);
                  }

                  onScroll() {
                  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

                  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                  requestAnimationFrame(this.hide.bind(this));
                  } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                  if (!this.preventReveal) {
                  requestAnimationFrame(this.reveal.bind(this));
                  } else {
                  window.clearTimeout(this.isScrolling);

                  this.isScrolling = setTimeout(() => {
                  this.preventReveal = false;
                  }, 66);

                  requestAnimationFrame(this.hide.bind(this));
                  }
                  } else if (scrollTop <= this.headerBounds.top) {
                                                               requestAnimationFrame(this.reset.bind(this));
                                                               }


                                                               this.currentScrollTop = scrollTop;
                                                               }

                                                               hide() {
                                                               this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                                                               this.closeMenuDisclosure();
                                                               this.closeSearchModal();
                                                               }

                                                               reveal() {
                                                               this.header.classList.add('shopify-section-header-sticky', 'animate');
                                                               this.header.classList.remove('shopify-section-header-hidden');
                                                               }

                                                               reset() {
                                                               this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                                                               }

                                                               closeMenuDisclosure() {
                                                               this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
                                                               this.disclosures.forEach(disclosure => disclosure.close());
                  }

                  closeSearchModal() {
                    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
                    this.searchModal.close(false);
                  }
                  }

                  customElements.define('sticky-header', StickyHeader);

                  // MENU DRAWER SEARCHBAR
                  const menuSearchBtn = document.querySelector("#menu-drawer-search-btn");
                  menuSearchBtn.addEventListener("click", e => {
                    e.preventDefault();

                    const navSearchIcon = document.querySelector(".header__icons summary span");
                    navSearchIcon.click();
                  });

                  // MENU DRAWER ACCORDIONS
                  const menuHeaders = document.querySelectorAll('.on--menu-drawer__category-header');
                  menuHeaders.forEach(header => header.addEventListener('click', function() {
                    const accordion = this.nextElementSibling;

                    if (!accordion) return;

                    console.log("AKKORDEON HEADER CLICKED!");

                    const isOpen = accordion.style.maxHeight;
                    accordion.style.maxHeight = isOpen ? null : accordion.scrollHeight + 'px';
                    this.classList.toggle('active');
                  }));

                  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-bundle-xl"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
    
      hide() {
        super.hide();
      }
    
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
    
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }
  
    customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-jump-tos_new"] && !window.DesignMode) return;
  try {
    
    const updateContents = () => {
      const windowWidth = window.innerWidth;
      
      // GET URL HASH PARAMETER 
      const url = window.location.href;
      const hashRegExp = /#([^?&]+)/;
      const hash = window.location.hash
        ? url.match(hashRegExp)[1]
        : "all";

      // SET CUSTOM EVENT WITH COLLECTION ID
      const changeCategoryEvent = new CustomEvent('shopAllCategoryChanged', {
        detail: hash
      });
      document.dispatchEvent(changeCategoryEvent);

      // BUTTON AND COLLECTION ELEMENTS
      const allButtons = document.querySelectorAll(".js-jumpto-btn");
      const allCollections = document.querySelectorAll(".collection--shop-all");
      const curCollection = document.querySelector(`.collection--shop-all#is-${hash}`);

      // REMOVE BUTTON ACTIVE STATES
      allButtons.forEach(button => button.classList.remove("on--jumpto-active"));
       
      if (hash == "all") {
        allCollections.forEach(collection => {
          // UNHIDE ALL COLLECTIONS
          collection.style.display = "block";

          // GET COLLECTIONS SHOW MORE BUTTON
          const btn = windowWidth > 750
            ? collection.querySelector(".show-more-btn#show-more-btn-desktop")
            : collection.querySelector(".show-more-btn#show-more-btn-mobile");
          
          // TRIGGER BUTTON CLICKS FOR ALL "SHOW MORE" BUTTONS
          if (typeof showAllFn == 'function' && btn) showAllFn({
            btn,
            forceShow: false,
            forceHide: true
          });
        });
      } else {
        // UNHIDE SELECTED COLLECTION
        allCollections.forEach(collection => collection.style.display = "none");
        curCollection.style.display = "block";  

        // GET COLLECTIONS SHOW MORE BUTTON
          const btn = windowWidth > 750
            ? curCollection.querySelector(".show-more-btn#show-more-btn-desktop")
            : curCollection.querySelector(".show-more-btn#show-more-btn-mobile");
        
        // TRIGGER BUTTON CLICK FOR SELECTED COLLECTION "SHOW MORE" BUTTON
        if (typeof showAllFn == 'function' && btn) showAllFn({
          btn,
          forceShow: true,
          forceHide: false
        });
      }

      // UPDATE BUTTON ACTIVE STATE
      const curButton = document.querySelector(`.js-jumpto-btn#is-${hash}`);
      curButton.classList.add("on--jumpto-active");

      // CLOSE MOBILE MENU
      const drawerContainer = document.querySelector("#Details-menu-drawer-container");
      drawerContainer.classList.remove("menu-opening");
      
      setTimeout(() => {
        drawerContainer.removeAttribute("open");
        document.body.classList.remove("overflow-hidden-tablet", "drawer-bg");
      }, 200);
    }; 
    updateContents();
   
    window.addEventListener("hashchange", updateContents);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-number-generator"]) return;
  try {
    
const DOM = {
    form: document.querySelector(".number-generator"),
    start: document.querySelector(".number-generator__start-num"),
    end: document.querySelector(".number-generator__end-num"),
    except: document.querySelector(".number-generator__except-nums"),
    submit: document.querySelector(".number-generator__submit"),
    result: document.querySelector(".number-generator__result")
}

class Basics {
    _validateForm(form) {
        let inputs = form.querySelectorAll("input");
        let areNotFilled = [...inputs].some(input => !input.value && input.getAttribute("required"));
        let areNotPositive = [...inputs].some(input => input.value < 0);
        
        let errorTxt;
        let isValid = true;

        DOM.result.innerHTML = "";

        if (areNotFilled) 
            errorTxt = "Start- und Endnummer müssen definiert werden."
        else if (areNotPositive) 
            errorTxt = "Keine negativen Nummern erlaubt.";
        
        if (areNotFilled || areNotPositive) {
            let error = `<span class="error-msg">${errorTxt}</span>`
            DOM.result.insertAdjacentHTML("beforeend", error);

            [...inputs].find(input => !input.value || input.value < 0).focus();

            return isValid = false;
        }

        return isValid;
    }
    
    _createRandomNum = (min, max) => {
        console.log(max - min + 1);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}

class NumberGenerator extends Basics {
    constructor() {
        super();

        DOM.submit.addEventListener('click', function(e) {
            e.preventDefault();

            if (!this._validateForm(DOM.form)) return;
            
            this._generateNum();
        }.bind(this))
    }

    _generateNum() {
        let start = +DOM.start.value,
            end = +DOM.end.value,
            excepts = DOM.except.value 
                        ? DOM.except.value.split(",").map(num => +num)
                        : null;

        if (start > end) {
            return DOM.result.insertAdjacentHTML("beforeend", "End Nummer muss größer sein als Start Nummer.");
        }

        let randomNum = this._createRandomNum(start, end);
        let counter = 0;

        while (excepts?.some(num => +num === randomNum)) {
            randomNum = this._createRandomNum(start, end);

            counter++;

            if (counter >= 1000) {
                return DOM.result.insertAdjacentHTML("beforeend", "Sämtliche mögliche Nummern wurden ausgeschlossen. Bitte passe deine Abfrage an.");
            }
        }

        DOM.result.innerHTML = "";
        DOM.result.insertAdjacentHTML("beforeend", `Die zufällig ausgewählte Nummer lautet: <span>${randomNum}</span>`);
    }
}

let numberGen = new NumberGenerator();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-video-slider-home"] && !window.DesignMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', (event) => {
    const videos = document.querySelectorAll('.on-video-slider .video');
    const muteBtns = document.querySelectorAll(".unmute-btn");
    let activeVideo = null; // Variable to keep track of the current active video

    const playVideoOnScroll = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting)
          entry.target.play();
        else
          entry.target.pause();
      });
    };
    const observer = new IntersectionObserver(playVideoOnScroll, { root: null, threshold: 0.1, rootMargin: '-120px' });

    // Function to update the active video and observer
    const updateActiveVideo = (newActiveVideo) => {
      if (activeVideo) {
        observer.unobserve(activeVideo); // Stop observing the old video
      }
      activeVideo = newActiveVideo;
      observer.observe(activeVideo); // Start observing the new video
    }
  
    const switchMutedVideos = () => {
      const iconSrcs = [
        "https://cdn.shopify.com/s/files/1/0615/8739/0701/files/mute_icon_white.png?v=1684762764",
        "https://cdn.shopify.com/s/files/1/0615/8739/0701/files/unmute_icon_white.png?v=1684762764"
      ]; 
      const videosMuted = muteBtns[0].querySelector("img").src == iconSrcs[0];
      
      // Switch all mute buttons' icons
      muteBtns.forEach(btn => {
        const muteIcon = btn.querySelector("img");
        muteIcon.src = videosMuted
          ? iconSrcs[1]
          : iconSrcs[0];
      });

      // Switch all videos' mute state
      videos.forEach(video => video.muted = !videosMuted);
    } 
    muteBtns.forEach(btn => {
      btn.addEventListener("click", switchMutedVideos);
    }); 
    
    const swiper = new Swiper('.on-video-slider.swiper-container', {
      slidesPerView: 'auto',
      centeredSlides: true, 
      spaceBetween: 10, 
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: false,
      },
      on: {
        init: function () {
          // Swipe to next video, when current one has ended
          videos.forEach((video, index) => video.onended = () => {
            if (index == (videos.length - 1)) {
              swiper.slideTo(0)
            } else {
              swiper.slideNext()
            }
          });

          // Start observing current slide's video
          updateActiveVideo(this.slides[this.activeIndex].querySelector(".video"));
        },
        slideChange: function () {
          const activeSlide = this.slides[this.activeIndex];
          const activeSlideVideo = activeSlide.querySelector(".video");

          // Pause all inactive videos
          videos.forEach((video, index) => {
            if (index == this.activeIndex) return;
            
            video.currentTime = 0;
            video.pause();
          });
          
          // Play current slide's video
          activeSlideVideo.play();

          // Start observing current slide's video
          updateActiveVideo(this.slides[this.activeIndex].querySelector(".video"));
        },
      },
    });

    // Initially observe the first video
    updateActiveVideo(videos[0]);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-video-slider"] && !window.DesignMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', (event) => {
    const videos = document.querySelectorAll('.on-video-slider .video');
    const jumpToBtns = document.querySelectorAll('.on--jump-tos__btn');
    const muteBtns = document.querySelectorAll(".unmute-btn");
  
    const switchMutedVideos = () => {
      const iconSrcs = [
        "https://cdn.shopify.com/s/files/1/0615/8739/0701/files/mute_icon_white.png?v=1684762764",
        "https://cdn.shopify.com/s/files/1/0615/8739/0701/files/unmute_icon_white.png?v=1684762764"
      ]; 
      const videosMuted = muteBtns[0].querySelector("img").src == iconSrcs[0];
      
      // Switch all mute buttons' icons
      muteBtns.forEach(btn => {
        const muteIcon = btn.querySelector("img");
        muteIcon.src = videosMuted
          ? iconSrcs[1]
          : iconSrcs[0];
      });

      // Switch all videos' mute state
      videos.forEach(video => video.muted = !videosMuted);
    } 
    muteBtns.forEach(btn => {
      btn.addEventListener("click", switchMutedVideos);
    }); 
    
    const swiper = new Swiper('.on-video-slider.swiper-container', {
      slidesPerView: 'auto',
      centeredSlides: true, 
      spaceBetween: 40, 
      navigation: {
        nextEl: '.on-video-slider .swiper-button-next',
        prevEl: '.on-video-slider .swiper-button-prev',
      },
      on: {
        init: function () {
          const activeSlide = this.slides[this.activeIndex];
          const activeVideo = activeSlide.querySelector(".video");
          
          videos.forEach((video, index) => video.onended = () => {
            if (index == (videos.length - 1)) {
              swiper.slideTo(0)
            } else {
              swiper.slideNext()
            }
          }); 
        },
        slideChange: function () {
          const activeSlide = this.slides[this.activeIndex];
          const activeVideo = activeSlide.querySelector(".video");

          // Pause all inactive videos
          videos.forEach((video, index) => {
            if (index == this.activeIndex) return;
            
            video.currentTime = 0;
            video.pause();
          });
          
          // Play current slide's video
          activeVideo.play();

          // Change heading based on active slide
          const heading = document.querySelector(".on-video-slider h2");
          heading.textContent = activeSlide.dataset.heading;

          // Deactivate inactive buttons
          jumpToBtns.forEach(btn => btn.classList.remove("on--jumpto-active"));
          
          // Activate active button
          jumpToBtns[this.activeIndex].classList.add("on--jumpto-active"); 
        },
      },
    });

    jumpToBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        swiper.slideTo(btn.dataset.slide);
      });
    });

    const playVideoOnScroll = (entries, observer) => {
      const entry = entries[0];
      
      if (entry.isIntersecting) {
        entry.target.play(); 
        observer.unobserve(entry.target);
      }
    }; 
    const observer = new IntersectionObserver(playVideoOnScroll, { root: null, threshold: 0.1, rootMargin: '-120px' });
    observer.observe(videos[0]);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            $(".product-recommendations .on--slider__slides-wrapper").slick({
              infinite: true,
              initialSlide: 0,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true, 
              variableWidth: true,
              arrows: false,
              customPaging: function(slider, i) {
                return `<button class="slick-slider-dot"></button>`;
              },
              dots: true,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                  {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    centerMode: true, 
                    variableWidth: true,
                  }
                }
              ]
            });
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
